import React, { useRef, useEffect, useCallback, useState} from 'react';
import ParameterEnabledButton from './ParameterEnabledButton.js';
import AccumulatorDepth from './AccumulatorDepth.js';
import LinkedParameterVisualizer from "components/parameters/LinkedParameterVisualizer.js";
import {usePreventDragging} from './preventDragging';
import {
    setAccumulatorParameterSelected,
    setIsMacroMapping} from 'actions/index.js';
import MacroMapButton from './macros/MacroMapButton.js';
import {connect} from 'react-redux';

const AccumulatorMapper = ({
    isDraggable,
    i,
    onMapped,
    effect,
    isMapping,
    parameterToMap,
    isSelected,
    setIsMacroMapping,
    parameterSelected,
    label,
    setAccumulatorParameterSelected,
    skipSelected
}) => { 
    let [mapClicked, setMapClicked] = useState(false);
    let ref = useRef(undefined);
    let {preventDragging} = usePreventDragging({ref});

    const unmap = useCallback(() => {
        effect.unmapParameter(i);
        onMapped();
    }, [i]);

    useEffect(() => {
        if (mapClicked) {
            setAccumulatorParameterSelected(undefined);
        }
    }, [mapClicked]);

    useEffect(() => {
        if (isMapping && parameterToMap && mapClicked && effect._parameters[i] !== parameterToMap) {
            effect.setParameter(parameterToMap, i);
            onMapped();
            setIsMacroMapping(false);
            if (!skipSelected) {
                setAccumulatorParameterSelected(parameterToMap);
            }
            setMapClicked(false);
        }
    }, [isMapping, parameterToMap, isSelected, mapClicked, i, onMapped, setMapClicked]);

    useEffect(() => {
        return () => {
            setAccumulatorParameterSelected(undefined);
            setIsMacroMapping(false);
        };
    }, []);

    let className = "accumulator-mapper";
    if (mapClicked) {
        className += " mapping";
    }

    if (isMapping && !mapClicked) {
        className += " disable";
    }

    return (
        <div
          onMouseDown={() => isDraggable && preventDragging(false)}
          onMouseUp={() => isDraggable && preventDragging(true)}
          ref={ref} className={className}>
          <MacroMapButton label={label} onClick={setMapClicked}/>
          {effect._parameters[i] && <ParameterEnabledButton i={i} effect={effect}/>}
          {effect._parameters[i] &&
           <ParameterMapping
             parameterSelected={parameterSelected}
             setAccumulatorParameterSelected={setAccumulatorParameterSelected}
             parameter={effect._parameters[i]}/>}
          {effect._parameters[i] && <div  className="acc-parameter-value">{effect._parameters[i].get(true)}</div>}
          {effect._parameters[i] && <AccumulatorDepth isDraggable={isDraggable} accumulator={effect} i={i} parameter={effect._parameters[i]}/>}
          {effect._parameters[i] && <div onClick={unmap} className="delete-parameter-btn">x</div>}
        </div>
    );
}

const ParameterMapping = ({
    setAccumulatorParameterSelected,
    parameter,
    parameterSelected
}) => {
    let ref = useRef(undefined);
    let isSelected = parameter === parameterSelected;
    return (
        <div
          ref={ref}
          id={isSelected ? "accumulator-map-source" : ''}
          onClick={() => setAccumulatorParameterSelected(isSelected ? undefined : parameter)}
          className={isSelected ? "selected mapped-parameter" : "mapped-parameter"}>
          {parameter.name}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let json = {
        isSelected: state.effects.selectedEffect === props.effect.id,
        isMapping: state.effects.isMacroMapping,
        parameterToMap: state.effects.isMacroMapping && state.effects.parameterToMap,
        parameterSelected: state.effects.accumulatorParameterSelected
    };
    for (let parameter of props.effect._parameters) {
        if (parameter) {
            json[parameter.id] = parameter.get(true);
        }
    }
    return json;
};

const mapDispatchToProps = (dispatch) => {
  return {
      setIsMacroMapping: (isMapping) => dispatch(
            setIsMacroMapping(isMapping)),
      setAccumulatorParameterSelected: (param) => dispatch(
          setAccumulatorParameterSelected(param))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccumulatorMapper);
